import { updateOffer } from '../../../../../shared/redux/reducers';

export function CommercialOwnershipWidget($scope, addFormService, store) {
  'ngInject';

  $scope.onChange = homeOwner => {
    addFormService.setValueByPath('homeOwner', homeOwner);

    store.dispatch(updateOffer({ homeOwner }));
  };

  $scope.clearHomeOwner = () => {
    addFormService.setValueByPath('homeOwner', undefined);
  };
}
